module.exports = __webpack_public_path__ + "static/media/lamina151.6b4566c0.png";